import * as React from 'react';

import FooterPanel from './components/FooterPanel';

export function renderFooterPanel(root, props: any) {
    root.render(<FooterPanel {...props} />);
}
